<template>
  <div style="display: flex; align-items: center">
    <button id="submit" :class="btnClass" :disabled="disabled">
      <span id="processing-text" style="display: none">
        <i class="fa fa-spin fa-spinner fa-lg" />
        Processing
      </span>
      <span id="button-text">
        <i class="fas fa-shopping-cart" />
        Pay {{ price }}
      </span>
    </button>
    <button
      v-if="showBackButton"
      id="stripe-back-btn"
      class="tdesk-secondary-button"
      style="margin-left: 3px"
      @click="$emit('go-back', true)"
    >
      <i class="fas fa-arrow-circle-left" />
      Back
    </button>
    <div id="form-errors" class="tdesk-secondary-notice failure" style="display: none;">
      <i class="fal" aria-hidden="true" />
      <span id="error-text" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      btnClass: { default: 'tdesk-primary-button', type: String },
      disabled: { required: true, type: Boolean },
      price: { required: true, type: String },
      showBackButton: { default: false, type: Boolean },
    },
  };
</script>
